import React from 'react';

function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbar-light tc-navbar-style2">
      <div className="container-fluid">
        <a className="navbar-brand" href="/home1">
          <img src="/home2/assets/img/DB_LOGO_COLOUR_WHITE___BLACK_-_Copy-removebg-preview.png" alt="db architekt logo" />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <div className="nav-contact">
            <div className="links-item">
              <a href="#">
              10,Basement,Vinobapuri
              Lajpat Nagar-2, <br /> New Delhi-110024
              </a>
            </div>
            <div className="links-item">
              <a href="db@dbarchitekt.com"> db@dbarchitekt.com </a>
              <a href=" 011 - 40079310"> 011 - 40079310 </a>
            </div>
          </div>
          <div className="nav-icons">
            <a href="#" className="icon">
              <i className="fal fa-globe"></i>
            </a>
            <a href="#" className="icon search_btn">
              <i className="fal fa-search"></i>
            </a>
            <div className="nav-search-box">
              <div className="form-group">
                <input type="text" placeholder="search word" />
                <button>
                  <i className="fal fa-search"></i>
                </button>
              </div>
            </div>
            <a href="#" className="icon side_menu_btn">
              <i className="fal fa-grip-lines"></i>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
